import { render, staticRenderFns } from "./RegisterSongStepButtons.vue?vue&type=template&id=f680c1ba&scoped=true"
import script from "./RegisterSongStepButtons.vue?vue&type=script&lang=ts"
export * from "./RegisterSongStepButtons.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f680c1ba",
  null
  
)

export default component.exports